import JourneyWithNextSchedule from '../../JourneyWithNextSchedule';
import { JourneyActionPayload, getCurrentSchedule } from '..';
import { ISchedules } from '../../../../services/journey.service';

export const AwaitingConsultationSmall = ({ journey }: JourneyActionPayload) => {
  const currentSchedule = getCurrentSchedule(journey);

  return (
    <>
      <JourneyWithNextSchedule journey={journey} schedule={currentSchedule as ISchedules} />
    </>
  );
};
